export const default_white = {
  id: 1,
  name: "Default(white mode)",
  typeId: 1,
  styleId: 1,
  sectionA: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "orderDetail",
          index: 0,
          title: "Order Detail",
          subComponents: [],
        },
      ],
    },
    {
      step: 2,
      align: "vertical",
      components: [
        {
          name: "orderSummary",
          index: 0,
          title: "Order Summary2",
          subComponents: [],
        },
      ],
    },
  ],
  sectionB: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "deliveryInfo",
          index: 0,
          title: "Delivery Info",
          subComponents: [],
        },
      ],
    },
    {
      step: 2,
      align: "vertical",
      components: [
        {
          name: "termsAndConditions",
          index: 0,
          title: "Terms and Comditions",
          subComponents: [],
        },
      ],
    },
    {
      step: 3,
      align: "vertical",
      components: [
        {
          name: "paymentMethod",
          index: 0,
          title: "Payment Method",
          subComponents: [],
        },
      ],
    },
  ],
  sectionC: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "paymentSuccessful",
          index: 0,
          title: "Payment Successful",
          subComponents: [],
        },
      ],
    },
  ],
};
export const default_dark = {
  id: 2,
  name: "Default(dark mode)",
  typeId: 1,
  styleId: 2,
  sectionA: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "orderDetail",
          index: 0,
          title: "Order Detail",
          subComponents: [],
        },
      ],
    },
    {
      step: 2,
      align: "vertical",
      components: [
        {
          name: "orderSummary",
          index: 0,
          title: "Order Summary2",
          subComponents: [],
        },
      ],
    },
  ],
  sectionB: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "deliveryInfo",
          index: 0,
          title: "Delivery Info",
          subComponents: [],
        },
      ],
    },
    {
      step: 2,
      align: "vertical",
      components: [
        {
          name: "termsAndConditions",
          index: 0,
          title: "Terms and Comditions",
          subComponents: [],
        },
      ],
    },
    {
      step: 3,
      align: "vertical",
      components: [
        {
          name: "paymentMethod",
          index: 0,
          title: "Payment Method",
          subComponents: [],
        },
      ],
    },
  ],
  sectionC: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "paymentSuccessful",
          index: 0,
          title: "Payment Successful",
          subComponents: [],
        },
      ],
    },
  ],
};
// export const poshNosh_white = {
//   id: 3,
//   name: "Posh Nosh(white mode)",
//   typeId: 2,
//   styleId: 1,
//   sectionA: [
//     {
//       step: 1,
//       align: "vertical",
//       components: [
//         {
//           name: "orderDetail",
//           type: "",
//           index: 0,
//           title: "",
//           subComponents: [],
//         },
//         {
//           name: "contactForm",
//           type: "",
//           index: 2,
//           title: "Contact Us",
//           subComponents: [],
//         },
//         {
//             name: "availablePayments",
//             type: "",
//             index: 3,
//             title: "",
//             subComponents: [],
//           },
//         { name: "footer", type: "", index: 4, title: "", subComponents: [] },
//       ],
//     },
//     {
//       step: 2,
//       align: "vertical",
//       components: [
//         {
//           name: "orderSummary",
//           type: "",
//           index: 0,
//           title: "Order Summary",
//           subComponents: [],
//         },
//         {
//           name: "deliveryInfo",
//           type: "",
//           index: 1,
//           title: "Delivery Information",
//           subComponents: [],
//         },
//         {
//           name: "termsAndConditions",
//           type: "",
//           index: 2,
//           title: "",
//           subComponents: [],
//         },
//         {
//           name: "paymentMethod",
//           type: "",
//           index: 3,
//           title: "",
//           subComponents: [],
//         },
//         { name: "footer", type: "", index: 5, title: "", subComponents: [] },
//       ],
//     },
//   ],
//   sectionB: [],
//   sectionC: [
//     {
//       step: 1,
//       align: "vertical",
//       components: [
//         {
//           name: "deliveryInfo",
//           type: "only-read",
//           index: 0,
//           title: "Delivery Information",
//           subComponents: [],
//         },
//         {
//           name: "contactForm",
//           type: "",
//           index: 1,
//           title: "Contact Us",
//           subComponents: [],
//         },
//         { name: "footer", type: "", index: 4, title: "", subComponents: [] },
//       ],
//     },
//   ],
//   customizedSection: {
//     showLogo: true,
//     copyRight: "merchant",
//     contactContent: {
//       IG: "poshnoshhk",
//       tel: "3188 9390",
//       email: "Sales@hkposhnosh.com",
//       title: "Contact Us",
//       address:
//         "Flat 03, 13/F, Fo Tan Industrial Centre,26-28 Au Pui Wan Street, Fo Tan, N.T.",
//       facebook: "PoshNosh",
//       whatsapps: "8489 3168",
//     },
//   },
// };
// export const poshNosh_dark = {
//   id: 4,
//   name: "Posh Nosh(dark mode)",
//   typeId: 2,
//   styleId: 2,
//   sectionA: [
//     {
//       step: 1,
//         align: "vertical",
//         components: [
//             {
//             name: "orderDetail",
//             type: "",
//             index: 0,
//             title: "",
//             subComponents: [],
//             },
//             {
//             name: "contactForm",
//             type: "",
//             index: 1,
//             title: "Contact Us",
//             subComponents: [],
//             },
//             {
//                 name: "availablePayments",
//                 type: "",
//                 index: 2,
//                 title: "",
//                 subComponents: [],
//             },
//             { name: "footer", type: "", index: 3, title: "", subComponents: [] },
//         ],
//     },
      
    
//     {
//       step: 2,
//       align: "vertical",
//       components: [
//         {
//           name: "orderSummary",
//           type: "",
//           index: 0,
//           title: "Order Summary",
//           subComponents: [],
//         },
//         {
//           name: "deliveryInfo",
//           type: "",
//           index: 1,
//           title: "Delivery Information",
//           subComponents: [],
//         },
//         {
//           name: "termsAndConditions",
//           type: "",
//           index: 2,
//           title: "",
//           subComponents: [],
//         },
//         {
//           name: "paymentMethod",
//           type: "",
//           index: 3,
//           title: "",
//           subComponents: [],
//         },
//         { name: "footer", type: "", index: 5, title: "", subComponents: [] },
//       ],
//     },
//   ],
//   sectionB: [],
//   sectionC: [
//     {
//       step: 1,
//       align: "vertical",
//       components: [
//         {
//           name: "deliveryInfo",
//           type: "only-read",
//           index: 0,
//           title: "Delivery Information",
//           subComponents: [],
//         },
//         {
//           name: "contactForm",
//           type: "",
//           index: 1,
//           title: "Contact Us",
//           subComponents: [],
//         },
//         { name: "footer", type: "", index: 4, title: "", subComponents: [] },
//       ],
//     },
//   ],
//   customizedSection: {
//     showLogo: true,
//     copyRight: "merchant",
//     contactContent: {
//       IG: "poshnoshhk",
//       tel: "3188 9390",
//       email: "Sales@hkposhnosh.com",
//       title: "Contact Us",
//       address:
//         "Flat 03, 13/F, Fo Tan Industrial Centre,26-28 Au Pui Wan Street, Fo Tan, N.T.",
//       facebook: "PoshNosh",
//       whatsapps: "8489 3168",
//     },
//   },
// };
export const default_white_A = {
  id: 14,
  name: "Default(white mode, id=14)",
  typeId: 1,
  styleId: 1,
  sectionA: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "orderDetail",
          index: 0,
          title: "Order Detail",
          subComponents: [],
        },
      ],
    },
    {
      step: 2,
      align: "vertical",
      components: [
        {
          name: "orderSummary",
          index: 0,
          title: "Order Summary2",
          subComponents: [],
        },
      ],
    },
  ],
  sectionB: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "deliveryInfo",
          index: 0,
          title: "Delivery Info",
          subComponents: [],
        },
      ],
    },
    {
      step: 2,
      align: "vertical",
      components: [
        {
          name: "termsAndConditions",
          index: 0,
          title: "Terms and Comditions",
          subComponents: [],
        },
      ],
    },
    {
      step: 3,
      align: "vertical",
      components: [
        {
          name: "paymentMethod",
          index: 0,
          title: "Payment Method",
          subComponents: [],
        },
      ],
    },
  ],
  sectionC: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "paymentSuccessful",
          index: 0,
          title: "Payment Successful",
          subComponents: [],
        },
      ],
    },
  ],
};
export const default_white_B = {
  name: "Delivery Info in Section A",
  typeId: 1,
  sectionA: [
    {
      step: 1,
      align: "vertical",
      components: [{ name: "orderDetail", index: 0, subComponents: [] }],
    },
    {
      step: 2,
      align: "vertical",
      components: [
        {
          name: "orderSummary",
          index: 0,
          subComponents: [{ name: "deliveryInfo" }],
        },
      ],
    },
  ],
  sectionB: [
    {
      step: 1,
      align: "vertical",
      components: [{ name: "termsAndConditions", index: 0, subComponents: [] }],
    },
    {
      step: 2,
      align: "vertical",
      components: [{ name: "paymentMethod", index: 0, subComponents: [] }],
    },
  ],
  sectionC: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "paymentSuccessful",
          index: 0,
          title: "Payment Successful",
          subComponents: [],
        },
      ],
    },
  ],
};
export const default_white_C = {
  name: "Delivery Info in Section A & No Terms and Conditions",
  typeId: 1,
  sectionA: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "orderDetail",
          index: 0,
          title: "Order Detail",
          subComponents: [],
        },
      ],
    },
    {
      step: 2,
      align: "vertical",
      components: [
        {
          name: "orderSummary",
          index: 0,
          title: "Order Summary",
          subComponents: [{ name: "deliveryInfo", title: "Delivery Info" }],
        },
      ],
    },
  ],
  sectionB: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "paymentMethod",
          index: 0,
          title: "Payment Method",
          subComponents: [],
        },
      ],
    },
  ],
  sectionC: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "paymentSuccessful",
          index: 0,
          title: "Payment Successful",
          subComponents: [],
        },
      ],
    },
  ],
};
export const default_white_D = {
  name: "Delivery Info In Section C",
  typeId: 1,
  sectionA: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "orderDetail",
          index: 0,
          title: "Order Detail",
          subComponents: [],
        },
      ],
    },
    {
      step: 2,
      align: "vertical",
      components: [
        {
          name: "orderSummary",
          index: 0,
          title: "Order Summary",
          subComponents: [],
        },
      ],
    },
  ],
  sectionB: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "termsAndConditions",
          index: 0,
          title: "Terms and Conditions",
          subComponents: [],
        },
      ],
    },
    {
      step: 2,
      align: "vertical",
      components: [
        {
          name: "paymentMethod",
          index: 0,
          title: "Payment Method",
          subComponents: [],
        },
      ],
    },
  ],
  sectionC: [
    {
      step: 1,
      align: "vertical",
      components: [
        {
          name: "paymentSuccessful",
          index: 0,
          title: "payment Successful",
          subComponents: [],
        },
      ],
    },
    {
      step: 2,
      align: "vertical",
      components: [
        {
          name: "deliveryInfo",
          index: 0,
          title: "Delivery Info",
          subComponents: [],
        },
      ],
    },
  ],
};
